import ChallengePattern from './ChallengePattern';

export default ChallengePattern;
